"use client";

import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { CompanyDeals } from "@/features/companies/components/CompanyDeals";
import type { CompanyEntity } from "@/lib/types/company";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Communications } from "@/src/gql/graphql";

export function CommunicationsDealsDisplay({ item }: TabContentProps<Communications>) {
  const communication = item;

  if (!communication.company_id) {
    return (
      <Card>
        <CardContent>
          <div className="text-center py-8 text-gray-500">
            <p>Link a company to this communication to view related deals.</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <CompanyDeals
      company={{
        id: communication.company_id,
        name: communication.company_name || "Linked company",
      } as CompanyEntity}
    />
  );
}
